import { arraysEqual } from "@perxis-auto/shared";
import "react";
import "@perxis-auto/shared/lib";
import "../../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "../../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/store/config/middleware/index.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import { selectSort } from "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import { selectFilterSortValue } from "./selectFilterSortValue.js";
const selectIsInitialSortValuesSelected = createAppSelector(
  [selectSort, selectFilterSortValue],
  ({ initialValues: initialSortValues }, sortValues) => arraysEqual(initialSortValues, sortValues)
);
export {
  selectIsInitialSortValuesSelected
};
